// Add new credits by appending an object to this array.
// Shape: { title (string), roles (string), year (string), status? (string) }
// status is optional — use it for works in progress (e.g. 'In Production').
const filmCredits = [
  {
    title: '8 Women 8 Lives 8 Stories',
    roles: 'Director, Cinematographer',
    year: '2026',
    status: 'In Production',
  },
  {
    title: 'Painting Lounge Free Paint Night',
    roles: 'Director, Cinematographer',
    year: '2025',
  },
];

export default filmCredits;
